import { defineComponent as n, openBlock as o, createElementBlock as i, createElementVNode as t } from "vue";
import { _ as l } from "../../../_plugin-vue_export-helper-dad06003.js";
const s = n({
  name: "VSpinner",
  props: {
    size: {
      type: Number,
      default: 24
    },
    color: {
      type: String,
      default: "#ffffff"
    }
  }
}), d = ["width", "height"], r = /* @__PURE__ */ t("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 1.41176C6.15228 1.41176 1.41176 6.15228 1.41176 12C1.41176 17.8477 6.15228 22.5882 12 22.5882C17.8477 22.5882 22.5882 17.8477 22.5882 12C22.5882 6.15228 17.8477 1.41176 12 1.41176ZM0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
  fill: "#D8D8D8"
}, null, -1), p = /* @__PURE__ */ t("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M23.2941 12.7059C22.9043 12.7059 22.5882 12.3898 22.5882 12C22.5882 6.15227 17.8477 1.41175 12 1.41175C11.6102 1.41175 11.2941 1.09572 11.2941 0.705873C11.2941 0.316024 11.6102 -9.8692e-06 12 -9.90328e-06C18.6274 -1.04827e-05 24 5.37257 24 12C24 12.3898 23.684 12.7059 23.2941 12.7059Z",
  fill: "#FF7E21"
}, null, -1), f = [
  r,
  p
];
function c(e, a, C, _, h, m) {
  return o(), i("svg", {
    class: "tw-inline-block tw-align-middle tw-animate-spin",
    width: e.size,
    height: e.size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, f, 8, d);
}
const g = /* @__PURE__ */ l(s, [["render", c]]);
export {
  g as default
};
